import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../../components/layout";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Breadcrumbs,
  Button,
  Modal,
  RadioButtonList,
  Textfield,
} from "../../../../components/core";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Strings } from "../../../../constants/strings";
import { useMutation, useQuery } from "@apollo/client";
import { CREATE_OPERATOR_ACCOUNT_ROLE } from "../../../../constants/graphql/operator_account_roles";
import useSidebarStore from "../../../../zustand/stores/sidebar-store";
import { sidebar } from "../../../../constants/sidebar"; // Import your sidebar configuration
import { QUERY_Wallet_Operator } from "../../../../constants/graphql/drop-off-graphql";

const breadcrumbItems = [
  { label: "Roles and Template", path: `/roles-and-templates/` },
  { label: "Add Template", path: "#" },
];

export default function AddTemplate() {
  const navigate = useNavigate();
  const location = useLocation();
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
  const localAccessedSidebar = useSidebarStore(
    (state) => state.localAccessedSidebar
  );

  console.log({ localAccessedSidebar });
  const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
  const setPendingNavigation = useSidebarStore(
    (state) => state.setPendingNavigation
  );
  const activeSubItem = useSidebarStore((state) => state.activeSubItem);
  const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);

  const [searchCriteria, setSearchCriteria] = React.useState({
    operatorId: operatorId,
    roleName: "",
    accessPermissions: "",
  });

  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });

  const [pageGroup, setPageGroup] = React.useState([]);
  const [pageList, setPageList] = React.useState([]);
  const [changesMade, setChangesMade] = useState(false);
  const [parsedParentPermission, setParsedParentPermission] = useState({});

  // Query to get operator access permissions
  const { data: findOperatorAccessPermission } = useQuery(
    QUERY_Wallet_Operator,
    {
      variables: { operatorId: operatorId },
    }
  );

  //gql
  const [createOperatorAccountRole] = useMutation(CREATE_OPERATOR_ACCOUNT_ROLE);

  // Transform sidebar configuration into page list
  const transformSidebarToPageList = (sidebarConfig) => {
    return sidebarConfig.flatMap((section) => {
      const groupName = section.title.toLowerCase().replaceAll(" ", "-");

      return section.content.flatMap((item) => {
        // Handle items with nested content (like Payment On Delivery, Storage Rental Fees, etc.)
        if (item.content && item.content.length > 0) {
          // Create entries for each sub-item
          return item.content.map((subItem) => ({
            name: subItem.title,
            group: groupName,
            value: subItem.tag,
            permissions: [
              { id: "0", text: "No Access", checked: false },
              { id: "1", text: "Read Only", checked: false },
              { id: "2", text: "Read & Write", checked: false },
              { id: "5", text: "Read, write, & accept/reject", checked: false },
            ],
          }));
        } else {
          // Regular item without nested content
          return {
            name: item.title,
            group: groupName,
            value: item.tag,
            permissions: [
              { id: "0", text: "No Access", checked: false },
              { id: "1", text: "Read Only", checked: false },
              { id: "2", text: "Read & Write", checked: false },
              { id: "5", text: "Read, write, & accept/reject", checked: false },
            ],
          };
        }
      });
    });
  };

  // const handleOnGroupCheckChange = (event) => {
  //   const { name, id } = event.target;
  //   const groupName = name.split("hello")[0];

  //   // Find relevant pages for this group to check parent permissions
  //   const pagesInGroup = pageList.filter((page) => page.group === groupName);

  //   // Check if the selected permission level exceeds parent permission
  //   let canAssignPermission = true;

  //   // Check parent permission for all pages in this group
  //   for (const page of pagesInGroup) {
  //     const parentPermissionLevel = parseInt(
  //       parsedParentPermission[page.value] || "0"
  //     );

  //     // If trying to assign higher permission than parent has
  //     if (
  //       parseInt(id) !== 3 &&
  //       id !== "3" &&
  //       parseInt(id) > parentPermissionLevel
  //     ) {
  //       canAssignPermission = false;
  //       break;
  //     }
  //   }

  //   // If can't assign this permission level, show alert and return early
  //   if (!canAssignPermission) {
  //     alert("You cannot assign a higher permission level than what you have.");
  //     return;
  //   }

  //   setChangesMade(true);

  //   // Update pageGroup
  //   let tempPageGroup = [...pageGroup];
  //   const groupIndex = tempPageGroup.findIndex((x) => x.value === groupName);
  //   if (groupIndex !== -1) {
  //     tempPageGroup[groupIndex] = { ...tempPageGroup[groupIndex], checked: id };
  //     setPageGroup(tempPageGroup);
  //   }

  //   // Update pageList
  //   let updatedPageList = pageList.map((page) => {
  //     if (page.group === groupName) {
  //       return {
  //         ...page,
  //         permissions: page.permissions.map((permission) => {
  //           if (id === "3") {
  //             return { ...permission, checked: false };
  //           } else {
  //             // Set only the permission matching the group's checked value
  //             return { ...permission, checked: permission.id === id };
  //           }
  //         }),
  //       };
  //     }
  //     return page; // Leave other pages unchanged
  //   });

  //   setPageList(updatedPageList);
  // };
  const handleOnGroupCheckChange = (event) => {
    const { name, id } = event.target;
    const groupName = name.split("hello")[0];

    // Find relevant pages for this group to check parent permissions
    const pagesInGroup = pageList.filter((page) => page.group === groupName);

    // Check if the selected permission level exceeds parent permission
    let canAssignPermission = true;

    // Check parent permission for all pages in this group
    for (const page of pagesInGroup) {
      const parentPermissionLevel = parseInt(
        parsedParentPermission[page.value] || "0"
      );

      // If trying to assign higher permission than parent has
      if (
        parseInt(id) !== 3 &&
        id !== "3" &&
        parseInt(id) > parentPermissionLevel
      ) {
        canAssignPermission = false;
        break;
      }
    }

    // If can't assign this permission level, show alert and return early
    if (!canAssignPermission) {
      alert("You cannot assign a higher permission level than what you have.");
      return;
    }

    setChangesMade(true);

    // Update pageGroup
    let tempPageGroup = [...pageGroup];
    const groupIndex = tempPageGroup.findIndex((x) => x.value === groupName);
    if (groupIndex !== -1) {
      tempPageGroup[groupIndex] = { ...tempPageGroup[groupIndex], checked: id };
      setPageGroup(tempPageGroup);
    }

    // Update pageList - DEEP CLONE to avoid reference issues
    let updatedPageList = pageList.map((page) => {
      if (page.group === groupName) {
        return {
          ...page,
          permissions: page.permissions.map((permission) => {
            if (id === "3") {
              return { ...permission, checked: false };
            } else {
              return { ...permission, checked: permission.id === id };
            }
          }),
        };
      }
      // Return a NEW object for unchanged pages too
      return { ...page, permissions: [...page.permissions] };
    });

    setPageList(updatedPageList);
  };

  console.log({ pageGroup, pageList });
  useEffect(() => {
    if (
      localAccessedSidebar &&
      findOperatorAccessPermission?.operators?.length > 0
    ) {
      // Parse the access permissions from the query
      const accessPermissionsString =
        findOperatorAccessPermission.operators[0].operatorRole
          .accessPermissions;
      const parentAccessPermission = JSON.parse(accessPermissionsString);

      setParsedParentPermission(parentAccessPermission);

      // Transform sidebar to page list - using localAccessedSidebar instead
      const allPages = transformSidebarToPageList(localAccessedSidebar);

      // Apply permissions to each page
      const pageListWithPermissions = allPages.map((page) => {
        const permissionLevel = parentAccessPermission[page.value] || "0";

        return {
          ...page,
          maxParentPermission: permissionLevel,
          permissions: page.permissions.map((permission) => ({
            ...permission,
            checked: false, // Start with all unchecked for new template
          })),
        };
      });

      // Filter to only show pages where the operator has access (permission > 0)
      const filteredPageList = pageListWithPermissions.filter((page) => {
        const maxPermission = parseInt(page.maxParentPermission);
        return maxPermission > 0; // Only show pages where operator has at least read access
      });

      // Set the updated page list
      setPageList(filteredPageList);

      // Initialize pageGroup based on the groups in the page list
      const accessibleGroups = filteredPageList.reduce((acc, page) => {
        const groupExists = acc.find((group) => group.value === page.group);
        if (!groupExists) {
          // Default to "Custom assign" (3) for new templates
          acc.push({
            value: page.group,
            checked: "3", // Start with custom assign
          });
        }
        return acc;
      }, []);

      setPageGroup(accessibleGroups);
    }
  }, [localAccessedSidebar, findOperatorAccessPermission]);

  const validateFiels = () => {
    // Check for invalid states
    const invalidGroups = pageGroup.filter((group) => {
      if (group.checked === "3") {
        // Find corresponding pages in pageList
        const relatedPages = pageList.filter(
          (page) => page.group === group.value
        );

        // Check if all permissions in related pages are unchecked
        return relatedPages.every((page) =>
          page.permissions.every((permission) => !permission.checked)
        );
      }
      return false;
    });

    // If invalid groups exist, show an error message and exit
    if (invalidGroups.length > 0) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Error",
        message:
          "Some groups are marked as 'Custom assign' but have no permissions checked.",
        open: true,
        actions: (
          <div className="gap-2 w-full mx-auto">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      return;
    }

    if (searchCriteria.roleName === "") {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Error",
        message: "Role Name cannot be empty",
        open: true,
        actions: (
          <div className="gap-2 w-full mx-auto">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      return;
    } else {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
        title: Strings.popup_confirm_save_title,
        message: Strings.popup_confirm_save_massage,
        open: true,
        actions: (
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"No"}
              className={"p-2"}
            />
            <Button
              onClick={handleSaveChanges}
              value={"Yes"}
              className={"p-2"}
            />
          </div>
        ),
      });
    }
  };

  const handleSaveChanges = () => {
    // If no issues, proceed with saving changes
    let tempObj = {};
    pageList.forEach((data) => {
      data.permissions.forEach((item) => {
        if (item.checked === true) {
          tempObj[data.value] = item.id;
        }
      });
    });

    let tempSearchCriteria = { ...searchCriteria };
    tempSearchCriteria.accessPermissions = JSON.stringify(tempObj);

    createOperatorAccountRole({ variables: tempSearchCriteria })
      .then((data) => {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
          title: Strings.popup_success_message_edit,
          message: Strings.popup_success_message_edit,
          open: true,
          actions: (
            <div className="gap-2 w-full mx-auto">
              <Button
                onClick={() => setValidation({ open: false })}
                value={"OK"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
        navigate("/roles-and-templates");
      })
      .catch((e) => {
        if (e) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            title: Strings.popup_error_title,
            message: Strings.popup_error_message_add,
            open: true,
            actions: (
              <div className="gap-2 w-full mx-auto">
                <Button
                  onClick={() => setValidation({ open: false })}
                  value={"OK"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        }
      });
  };

  useEffect(() => {
    if (pendingNavigation !== null) {
      if (changesMade) {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: `${Strings.popup_confirm_cancel_title}?`,
          message: Strings.popup_confirm_cancel_massage,
          open: true,
          actions: (
            <div className="flex justify-between gap-3">
              <Button
                onClick={() => {
                  setValidation({ open: false });
                  setPendingNavigation(null);
                  setActiveSubItem(activeSubItem);
                }}
                value={"No"}
                className={"p-2 w-full"}
              />
              <Button
                onClick={() => {
                  navigate(pendingNavigation);
                  setPendingNavigation(null);
                }}
                value={"Yes"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
      } else {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }
    }
  }, [pendingNavigation, changesMade]);

  return (
    <>
      <Breadcrumbs items={breadcrumbItems} />
      <ContentContainer containerTitle={"ADD TEMPLATE"} className={"w-full"}>
        <div className="grid grid-cols-2 gap-2 w-1/3 my-4">
          <p className="my-auto">Operator:</p>
          <p className="font-bold">
            {JSON.parse(localStorage.getItem("user")).company}
          </p>
          <p className="">
            <i className="text-red-500">*</i> Role Name:
          </p>
          <Textfield
            placeholder={"Enter role name"}
            maxLength={64}
            name={"roleName"}
            onChange={(e) =>
              setSearchCriteria((prev) => ({
                ...prev,
                [e.target.name]: e.target.value,
              }))
            }
          />
        </div>
        <table className="w-3/4 border">
          <tbody>
            {pageGroup.map((group, groupKey) => {
              return (
                <tr key={groupKey} className="w-full">
                  <td
                    className="border border-secondary-darkGray w-full"
                    colSpan={2}
                  >
                    <Accordion style={{ width: "100%" }} activeIndex={0}>
                      <AccordionTab
                        headerClassName="w-full"
                        header={group.value.toUpperCase().replaceAll("-", " ")}
                        style={{ width: "100%" }}
                      >
                        <label className=" items-start space-x-2 p-1 flex mt-4">
                          <input
                            type="radio"
                            name={group.value + "hello"}
                            className="form-radio h-5 w-5 text-blue-600 my-auto"
                            checked={group.checked === "0"}
                            id={"0"}
                            onChange={handleOnGroupCheckChange}
                          />
                          <span className="my-auto">Set all to no access</span>
                        </label>
                        <label className=" items-start space-x-2 p-1 flex">
                          <input
                            type="radio"
                            name={group.value + "hello"}
                            className="form-radio h-5 w-5 text-blue-600 my-auto"
                            checked={group.checked === "1"}
                            id={"1"}
                            onChange={handleOnGroupCheckChange}
                          />
                          <span className="my-auto">Set all to read only</span>
                        </label>
                        <label className=" items-start space-x-2 p-1 flex">
                          <input
                            type="radio"
                            name={group.value + "hello"}
                            className="form-radio h-5 w-5 text-blue-600 my-auto"
                            checked={group.checked === "2"}
                            id={"2"}
                            onChange={handleOnGroupCheckChange}
                          />
                          <span className="my-auto">
                            Set all to read & write
                          </span>
                        </label>
                        <label className=" items-start space-x-2 p-1 flex">
                          <input
                            type="radio"
                            name={group.value + "hello"}
                            className="form-radio h-5 w-5 text-blue-600 my-auto"
                            checked={group.checked === "5"}
                            id={"5"}
                            onChange={handleOnGroupCheckChange}
                          />
                          <span className="my-auto">
                            Set all to read, write, & accept/reject
                          </span>
                        </label>
                        <label className=" items-start space-x-2 p-1 flex mb-4">
                          <input
                            type="radio"
                            name={group.value + "hello"}
                            className="form-radio h-5 w-5 text-blue-600 my-auto"
                            checked={group.checked === "3"}
                            id={"3"}
                            onChange={handleOnGroupCheckChange}
                          />
                          <span className="my-auto">Custom assign</span>
                        </label>

                        <table className="w-[90%] border-collapse border border-secondary-darkGray">
                          <tbody>
                            {pageList.map((data, key) => {
                              if (data.group === group.value) {
                                return (
                                  <tr key={key} className="w-full">
                                    <td className="p-2 border border-secondary-darkGray w-2/4">
                                      <p>{data.name}</p>
                                    </td>

                                    <td className="p-2 border border-secondary-darkGray">
                                      <div className="flex justify-center">
                                        <RadioButtonList
                                          disabled={
                                            pageGroup.find(
                                              (x) => x.value === data.group
                                            )?.checked !== "3"
                                          }
                                          dataItems={data.permissions}
                                          name={data.value}
                                          handleChange={(e) => {
                                            const selectedPermission =
                                              parseInt(e);
                                            const parentPermissionLevel =
                                              parseInt(
                                                parsedParentPermission[
                                                  data.value
                                                ] || "0"
                                              );

                                            if (
                                              selectedPermission >
                                              parentPermissionLevel
                                            ) {
                                              alert(
                                                "You cannot assign a higher permission level than what you have."
                                              );
                                              return;
                                            }

                                            setChangesMade(true);

                                            // Find the ACTUAL index in pageList using data.value
                                            const actualIndex =
                                              pageList.findIndex(
                                                (page) =>
                                                  page.value === data.value
                                              );

                                            let tempArr = [...pageList];
                                            tempArr[actualIndex].permissions =
                                              tempArr[
                                                actualIndex
                                              ].permissions.map(
                                                (permission) => ({
                                                  ...permission,
                                                  checked: permission.id === e,
                                                })
                                              );
                                            setPageList(tempArr);
                                          }}
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }
                            })}
                          </tbody>
                        </table>
                      </AccordionTab>
                    </Accordion>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="grid grid-cols-2 gap-2 w-1/3 my-4">
          <Button
            value={"Cancel"}
            className={"p-2"}
            onClick={() => {
              setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                title: Strings.popup_confirm_cancel_title,
                message: Strings.popup_confirm_cancel_massage,
                open: true,
                actions: (
                  <div className="grid grid-cols-2 gap-2">
                    <Button
                      onClick={() => setValidation({ open: false })}
                      value={"No"}
                      className={"p-2"}
                    />
                    <Button
                      onClick={() => {
                        navigate(`/roles-and-templates/`);
                      }}
                      value={"Yes"}
                      className={"p-2"}
                    />
                  </div>
                ),
              });
            }}
          />
          <Button
            value={"Save Changes"}
            className={"p-2"}
            disabled={!changesMade}
            onClick={validateFiels}
          />
        </div>
        <Modal
          icon={validation.icon}
          title={validation.title}
          message={validation.message}
          open={validation.open}
          actions={validation.actions}
        />
      </ContentContainer>
    </>
  );
}
